import { IPartsChildren } from "../../../types/IPartsConfigSchema";

export function getImplicitModulesNumber(
  conf: IPartsChildren["extraModules"],
  cells: number,
) {
  if (!conf) return 0;
  return conf.filter((m) => cells >= m.min && cells <= m.max)[0].n;
}
